import { Controller } from "@hotwired/stimulus";

export default class extends Controller {
  static values = {
    appId: Number
  };

  connect() {
    const drawerPortalEl = this.element.closest('[data-controller="drawer-portal"]');
    if (drawerPortalEl) {
      this.drawerPortalEl = drawerPortalEl;
      this.drawerPortalEl.addEventListener("drawer_portal:hide", this.onDrawerPortalHide.bind(this));
    }
  }

  disconnect() {
    if (this.drawerPortalEl) {
      this.drawerPortalEl.removeEventListener("drawer_portal:hide", this.onDrawerPortalHide.bind(this));
    }
  }

  onDrawerPortalHide(event) {
    // Only trigger app refresh if the drawer is being closed without a successful deactivation
    if (!this.isSuccessfulHire) {
      if (this.appRefreshController) {
        this.appRefreshController.appRefresh();
      }
    }
    this.isSuccessfulHire = false;
  }

  successNotice() {
    this.isSuccessfulHire = true;
  }

  get appRefreshController() {
    return this.application.getControllerForElementAndIdentifier(
      document.getElementById(`app-card-${this.appIdValue}`),
      "app-board-view-refresh"
    );
  }
}
